import { defineComponent as _defineComponent } from 'vue'
import { t } from '@/plugins/i18n';
import { useNewFloorStore } from '@/stores'
import {computed, onMounted} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RenameFloor',
  props: {
    stepIndex: null
  },
  setup(__props: any) {

const props = __props as {
  stepIndex: number
};



const newFloorStore = useNewFloorStore()
const uploadedFileUrl = computed(()=>newFloorStore.uploadedFileUrl)
const floorName = computed({
  get: () => newFloorStore.newFloorName,
  set: (value) => newFloorStore.$patch({newFloorName: value})
})
const floorNameLabel = computed(()=> `${t('Floor')} ${newFloorStore.selectedFloor}`)

onMounted(() => {
  newFloorStore.setIsCompletedStep(props.stepIndex, true);
})

return { __sfc: true,props, newFloorStore, uploadedFileUrl, floorName, floorNameLabel, t }
}

})